import { render } from "./DatasetTable.vue?vue&type=template&id=c4bb654a"
import script from "./DatasetTable.vue?vue&type=script&lang=js"
export * from "./DatasetTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__